<template>
  <div class="xc-modal xc-modal-page">
    <div class="xc-modal-wrap">
      <div class="xc-modal-content">
        <div class="xc-modal-header">
          <div class="xc-modal-title">发布节目</div>
          <div
            class="xc-modal-close"
            @click="layerClose"
          ></div>
        </div>
        <div
          class="xc-modal-body"
          style="padding-bottom: 0"
        >
          <div class="xc-form-inline">
            <div class="xc-form-item">
              <xc-form-item label="节目名称">
                <input
                  type="text"
                  v-model="mix_query.programName"
                  maxlength="255"
                  class="xc-input"
                  placeholder="请输入素材名称"
                >
              </xc-form-item>
            </div>
            <div class="xc-form-item">
              <xc-form-item label="节目来源">
                <select
                  class="xc-select"
                  v-model="mix_query.programOrigin"
                >
                  <option value="">全部</option>
                  <option
                    :value="item.value"
                    v-for="(item, index) in programOrigins"
                    :key="index"
                  >{{item.desc}}</option>
                </select>
              </xc-form-item>
            </div>
            <div class="xc-form-inline">
            <button
              type="submit"
              class="xc-btn xc-btn-primary"
              @click.prevent="mix_search"
            >查询</button>
          </div>
            <!-- <div class="xc-form-item">
              <xc-form-item label="投放区域">
                <select class="xc-select" v-model="mix_query.deviceGroupId">
                  <option value="">全部</option>
                  <option
                    :value="item.deviceGroupId"
                    v-for="(item, index) in putAreas"
                    :key="index"
                  >{{item.groupName}}</option>
                </select>
              </xc-form-item>
            </div> -->
          </div>
          
          <!-- 带滚动条的表格 -->
          <!-- class="xc-row-scroll" -->
            <!-- style="overflow:auto; max-height: 320px;" -->
          <div
          >
            <table class="xc-table">
              <thead>
                <th>
                  <input
                    type="checkbox"
                    class="xc-checkbox"
                    v-model="mix_isSelectAll"
                  >
                </th>
                <th>节目ID</th>
                <th>终端分辨率</th>
                <th>节目来源</th>
                <th>节目名称(时长)</th>
                <th>素材数</th>
                <th>状态</th>
                <th>投放时间</th>
                <th>创建人</th>
                <th>创建时间</th>
              </thead>
              <tbody>
                <template v-if="list && list.length">
                  <tr
                    v-for="(item,key) in list"
                    :key="key"
                  >
                    <td style="width: 45px;">
                      <input
                        type="checkbox"
                        class="xc-checkbox"
                        v-model="item.mix_checkbox"
                        @click="mix_selectListItem(item)"
                      >
                    </td>
                    <td>{{item.programId}}</td>
                    <td>{{item.deviceResolution}}</td>
                    <td>{{item.originName}}</td>
                    <td>{{item.programName}}({{item.programDuration/1000}}s)</td>
                    <td>{{item.sourceNum}}</td>
                    <td>{{item.programStatus}}</td>
                    <td>{{item.putinStartTime}}至<br/> {{item.putinEndTime}}</td>
                    <td>{{item.addUserName}}</td>
                    <td>{{item.addTime}}</td>
                  </tr>
                </template>
                <template v-else>
                  <tr>
                    <td
                      colspan="14"
                      class="xc-s-tac"
                    >暂无数据</td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </div>
        <div class="xc-modal-footer xc-flex-center">
          <div class="xc-btn-group">
            <div
              class="xc-btn xc-btn-default"
              @click="layerClose"
            >取消</div>
            <div
              class="xc-btn xc-btn-primary"
              @click="mix_batchAction('publishProgram',$event)"
            >确定发布</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import myLayerImport from "@/libs/myLayer";
import mixin from "../xc-ui/mixins/list";
import deviceApi from "../api/device";
import { mapState, mapActions } from 'vuex'


// vee-validate验证
import "@/libs/vee-validate";
import "@/utils/form-format";
import { setTimeout } from 'timers';

export default {
  name: "materialPreview",
  data() {
    return {
      channel: 1,
      deviceCodes: this.$route.query.deviceCodes,
      putAreas: [],
      list: [],
      mix_query: {
        programName: '',
        programOrigin: '',
        deviceGroupId: '',
      },

      // 获取参数
      program: this.$route.query,

    };
  },

  computed: {
    ...mapState([
      'globalConfig',
    ]),

    // 节目是否需要审核
    programCheck() {
      if (this.globalConfig.needAuthProgram && this.globalConfig.needAuthProgram.value == 'true') {
        return true
      } else {
        return false;
      }
    },

    // 节目来源
    programOrigins() {
      if (this.globalConfig) {
        return this.globalConfig.programOrigin
      }
    }
  },

  created() {
  },

  mounted() {
    let that = this;

    // 获取投放区域
    deviceApi.getDeviceGroupSelect().then(v => {
      this.putAreas = v.data;
    });
  },

  methods: {
    layerClose() {
      var index = parent.layer.getFrameIndex(window.name);
      parent.layer.close(index);
    },

    // 初始化数据
    initData(v) {
      // 默认搜索的数据
      const search = {
        ...this.mix_query
      };

      deviceApi.getProgramByDevices(search).then(v => {
        let ret = v;

        this.list = this.mix_format(ret.data);
        this.mix_total = ret.data.total;
        this.mix_page = ret.data.pageNum;
        this.mix_pageSize = ret.data.pageSize;
      });
    },

    // 批量操作
    batchAction(...args) {
      let that = this
      const action = args[0];
      const e = args[args.length - 1];

      // 批量操作的数据
      const { mix_checkedList } = this;

      switch (action) {

        // 批量发布
        case "publishProgram":
          // 获取设备序列号
          let programVersionArr = []
          for (let item of mix_checkedList) {
            programVersionArr.push(item.programVersion)
          }
          let programVersions = programVersionArr.join(',')

          deviceApi.fastPublishByProgramAndPointer(this.$route.query.deviceCodes, programVersions).then(v => {

            // 成功后关闭窗口

            if (this.programCheck) {
              that.$message.success("发布成功,请联系相关人员在节目列表审核!")
            } else {
              that.$message.success("发布成功!")
            }


            setTimeout(function () {
              that.layerClose()
            }, 3000)
          })

          break;

        default:
          break;
      }
    },

  },
  mixins: [mixin]
};
</script>

<style lang="scss" scoped>
.material {
  width: 100%;
  height: 100%;
  .myMaterial {
    width: 100%;
    height: 100%;
    border: 0;
  }
}
</style>
